module KendoWidgets
{
	export class EditorOptions implements kendo.ui.EditorOptions
	{
		name?: string;
		placeholder?: string;
		domain?: string;
		encoded?: boolean;
		messages?: kendo.ui.EditorMessages;
		pasteCleanup?: kendo.ui.EditorPasteCleanup;
		pdf?: kendo.ui.EditorPdf;
		resizable?: boolean | kendo.ui.EditorResizable;
		stylesheets?: any;
		imageBrowser?: kendo.ui.EditorImageBrowser;
		fileBrowser?: kendo.ui.EditorFileBrowser;

		customToolItems?: CustomToolItem[];
		width?: string | number;
		height?: string | number;
		windowWidth?: number;
		windowHeight?: number;
		enabled?: boolean;

		//#region Toolbar items
		formatting?: boolean;
		bold?: boolean;
		italic?: boolean;
		underline?: boolean;
		alignLeft?: boolean;
		alignCenter?: boolean;
		alignRight?: boolean;
		justify?: boolean;
		unorderedList?: boolean;
		orderedList?: boolean;
		link?: boolean;
		unlink?: boolean;
		viewHtml?: boolean;
		fontName?: boolean;
		fontSize?: boolean;
		color?: boolean;
		backgroundColor?: boolean;
		image?: boolean;
		print?: boolean;
		//#endregion

		change?(e: kendo.ui.EditorEvent): void;
		execute?(e: kendo.ui.EditorExecuteEvent): void;
		keydown?(e: kendo.ui.EditorEvent): void;
		keyup?(e: kendo.ui.EditorEvent): void;
		paste?(e: kendo.ui.EditorPasteEvent): void;
		pdfExport?(e: kendo.ui.EditorPdfExportEvent): void;
		select?(e: kendo.ui.EditorEvent): void;
	}

	export class Editor extends kendo.ui.Editor implements KendoWidget
	{
		public controlType(): ControlTypeEnum { return ControlTypeEnum.Editor; }

		constructor(element: Element, options?: KendoWidgets.EditorOptions)
		{
			if (options == null)
				options = new KendoWidgets.EditorOptions();

			//#region Default options
			if (options.windowWidth == null) options.windowWidth = 700;
			if (options.windowHeight == null) options.windowHeight = 400;

			if (options.formatting == null) options.formatting = true;
			if (options.bold == null) options.bold = true;
			if (options.italic == null) options.italic = true;
			if (options.underline == null) options.underline = true;
			if (options.alignLeft == null) options.alignLeft = true;
			if (options.alignCenter == null) options.alignCenter = true;
			if (options.alignRight == null) options.alignRight = true;
			if (options.justify == null) options.justify = true;
			if (options.unorderedList == null) options.unorderedList = true;
			if (options.orderedList == null) options.orderedList = true;
			if (options.link == null) options.link = true;
			if (options.unlink == null) options.unlink = true;
			if (options.viewHtml == null) options.viewHtml = true;
			if (options.enabled == null) options.enabled = true;
			//#endregion

			//#region Width and Height
			if (typeof (options.width) == "number")
				options.width = options.width + "px";
			(element as HTMLElement).style.cssText += "width: " + options.width;

			if (typeof (options.height) == "number")
				options.height = options.height + "px";
			(element as HTMLElement).style.cssText += "height: " + options.height;
			//#endregion

			//#region Tool items

			//#region Default
			let toolItems: string[] = [];
			if (options.formatting) toolItems.push(ToolEnum.Formatting);
			if (options.bold) toolItems.push(ToolEnum.Bold);
			if (options.italic) toolItems.push(ToolEnum.Italic);
			if (options.underline) toolItems.push(ToolEnum.Underline);
			if (options.alignLeft) toolItems.push(ToolEnum.AlignLeft);
			if (options.alignCenter) toolItems.push(ToolEnum.AlignCenter);
			if (options.alignRight) toolItems.push(ToolEnum.AlignRight);
			if (options.justify) toolItems.push(ToolEnum.Justify);
			if (options.unorderedList) toolItems.push(ToolEnum.UnorderedList);
			if (options.orderedList) toolItems.push(ToolEnum.OrderedList);
			if (options.link) toolItems.push(ToolEnum.Link);
			if (options.unlink) toolItems.push(ToolEnum.Unlink);
			if (options.viewHtml) toolItems.push(ToolEnum.ViewHtml);
			if (options.fontName) toolItems.push(ToolEnum.FontName);
			if (options.fontSize) toolItems.push(ToolEnum.FontSize);
			if (options.color) toolItems.push(ToolEnum.Color);
			if (options.backgroundColor) toolItems.push(ToolEnum.BackgroundColor);
			if (options.image) toolItems.push(ToolEnum.Image);
			if (options.print) toolItems.push(ToolEnum.Print);
			//#endregion

			//#region Custom tool items
			let customToolItems: any[] = [];
			if (options.customToolItems != null)
			{
				let i = 0;
				for (let customToolItem of options.customToolItems)
				{
					let id = (customToolItem.value != null) ? customToolItem.value : (element.id + "ToolItemCustom" + i);
					let icon = "";
					if (customToolItem.icon != null)
						icon = "<span class='k-tool-icon k-icon k-i-" + customToolItem.icon + "'></span>";
					else if (customToolItem.imageUrl != null)
						icon = "<img src='" + customToolItem.imageUrl + "' />";

					let label = (customToolItem.label != null) ? customToolItem.label : "";

					let customToolItemKendo: any = {};
					customToolItemKendo.name = id;
					customToolItemKendo.template = `<a id=` + id + ` style="cursor: pointer;" role="button" 
						class="k-tool k-group-start k-group-end">` + icon + label + `</a>`;

					if (customToolItem.click != null)
					{
						customToolItemKendo.exec = (e: any) =>
						{
							customToolItem.click!();
							return false;
						};
					}

					customToolItems.push(customToolItemKendo);
					i++;
				}
			}
			//#endregion

			(options as any).tools = [];
			(options as any).tools = (options as any).tools.concat(toolItems);
			(options as any).tools = (options as any).tools.concat(customToolItems);
			// #endregion

			super(element, options);

			//#region Enabled
			if (!options.enabled)
				this.disable();
			//#endregion
		}

		clear()
		{
			this.value("");
		}

		//#region Visible
		visible(visibleStatus?: boolean)
		{
			if (visibleStatus != null)
			{
				if (visibleStatus)
					$(this.element).closest(".k-editor").css("display", "table");
				else
					$(this.element).closest(".k-editor").css("display", "none")
			}

			return $(this.element).closest(".k-editor").is(":visible");
		}

		show()
		{
			this.visible(true);
		}

		hide()
		{
			this.visible(false);
		}
		//#endregion

		//#region Caret
		caretPosition()
		{
			return this.getSelection().focusOffset;
		}

		insertTextAtCursor(text: string)
		{
			this.exec("inserthtml", { value: text });
		}
		//#endregion

		//#region Enable
		enable()
		{
			$(this.body).attr("contenteditable", "true");
		}

		disable()
		{
			$(this.body).attr("contenteditable", "false");
		}
		//#endregion

		//#region Append
		appendTo(element: string | HTMLElement | JQuery)
		{
			this.element.parent().parent().parent().appendTo(element);
		}

		prependTo(element: string | HTMLElement | JQuery)
		{
			this.element.parent().parent().parent().prependTo(element);
		}
		//#endregion
	}

	Editor.fn = Editor.prototype;
	Editor.fn.options = $.extend(true, {}, kendo.ui.Editor.fn.options);
	Editor.fn.options.name = "Editor";
	kendo.ui.plugin(Editor);

	export enum ToolEnum
	{
		Bold = "bold",
		Italic = "italic",
		Underline = "underline",
		Strike = "strikethrough",
		FontName = "fontName",
		FontSize = "fontSize",
		Color = "foreColor",
		BackgroundColor = "backColor",
		AlignLeft = "justifyLeft",
		AlignCenter = "justifyCenter",
		AlignRight = "justifyRight",
		Justify = "justifyFull",
		UnorderedList = "insertUnorderedList",
		OrderedList = "insertOrderedList",
		Indent = "indent",
		Outdent = "outdent",
		Link = "createLink",
		Unlink = "unlink",
		Image = "insertImage",
		File = "insertFile",
		TableWizard = "tableWizard",
		Table = "createTable",
		Formatting = "formatting",
		CleanFormatting = "cleanFormatting",
		InsertHtml = "insertHtml",
		ViewHtml = "viewHtml",
		Print = "print",
		Pdf = "pdf"
	}

	export class CustomToolItem
	{
		value?: string;
		icon?: string;
		imageUrl?: string;
		click?(): void;
		label?: string;
	}
}

interface JQuery
{
	kendoEditor(options?: KendoWidgets.EditorOptions): JQuery;
}